<template>
    <div>
        <div class="row">
            <div class="col-12 " style="padding-right: 15px;">
                <ul style="padding-left: 0px; margin-bottom: 0px; overflow:auto;">
                   <li class="li-item-card-dash" style="display: flex; justify-content: space-between; align-items: center;">
                        <span class="txt-item-card-dash">
                            TOTAL CUSTO
                        </span>
                        <span v-show="parseFloat(vtotalcusto) > 0"
                            class="txt-item-card-dash">
                            {{ mtdformatavalordecimal(parseFloat(vtotalcusto)) }}
                        </span>
                    </li>
                    <li class="li-item-card-dash" style="display: flex; justify-content: space-between; align-items: center;">
                        <span class="txt-item-card-dash">
                            TOTAL VENDA
                        </span>
                        <span v-show="parseFloat(vtotalvenda) > 0"
                            class="txt-item-card-dash">
                            {{ mtdformatavalordecimal(parseFloat(vtotalvenda)) }}
                        </span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>


<script>
import { computed } from 'vue';
import util from '../../utilitarios/util';
export default {
    name: "BarChartCard",
    data: function name(params) {
        return {

            margemlucrogeral: 0,
            showpopover: false,
            isloading: false,
            vtotalvenda: 0,
            vtotalcusto: 0,
            usuariologado: this.$store.state.usuario,



        }

    },
    props: [
        'utodasfiliais',
        'idfilialmeta',
        'pdtini',
        'pdtfim',
        'lstfiliais',
    ],
    methods: {
        mtdformatavalordecimal(valor) {
            return util.formatarvalor(valor, '');
        },
        mtdresultadofaturamento() {
            var vself = this;

            vself.$emit('handlerLoader', true);
            let periodo = '"' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';


            let parametros = [
                { parametro: 'idclientesac',  valor: window.localStorage.getItem('idcliente') },
                { parametro: 'op',            valor: 'totalestoque' },
                { parametro: 'idusuario',     valor: vself.$store.state.usuario.id },
                { parametro: 'periodo',       valor: periodo },
                { parametro: 'usuariologado', valor: JSON.stringify(vself.usuariologado) },
                { parametro: 'filiais',       valor: JSON.stringify(vself.lstfiliais) },
                { parametro: 'diasemana',     valor: util.diasemanaintmysql() },
                { parametro: 'filtrotarefas', valor: '' },
                { parametro: 'patharquivos',  valor: '' },
            ];
            let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv + '/controller/dashboard.php');
            retorno.then(function (response) {

                try {
                    vself.vtotalvenda     = response.data[0]['totvenda'];
                    vself.vtotalcusto    = response.data[0]['totcusto'];
                } catch (error) {
                    console.log(error);
                }


                vself.$emit('handlerLoader', false);
            }).catch(function (response) {
                vself.vtotalvenda = 0;
                vself.vtotalcusto = 0;
                //loader.hide();
                vself.$emit('handlerLoader', false);
            });
        },
    },
    mounted() {
        this.mtdresultadofaturamento();
    },
    computed: {

    },
}
</script>
